import React, { FC } from 'react';
import styled from 'styled-components';
import { IProductAvailability } from '../../../graphql/types/index';
import { Grey2 } from '../../../styles/colours';
import { DemiBold, Medium } from '../../../styles/fonts';

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StyledTitle = styled.span`
  color: ${Grey2};
  font-size: 0.875rem;
  font-family: ${DemiBold};
  padding-right: 0.3rem;
`;

const StyledText = styled.div`
  font-size: 1.125rem;
  font-family: ${Medium};
`;

const StyledBreak = styled.div`
  margin: 0px 5px 0px 5px;
`;

export const PlantDetails: FC<{
  productAvailability: IProductAvailability;
}> = ({ productAvailability }) => {
  return (
    <StyledContainer>
      <StyledTitle>Plant: </StyledTitle>
      <StyledText>{productAvailability.plant.id}</StyledText>
      <StyledBreak>-</StyledBreak>
      <StyledText>{productAvailability.plant.description}</StyledText>
    </StyledContainer>
  );
};
